import React, { FC } from 'react';
import FormBlock from 'src/components/FormBlock';
import { ReturnType } from 'src/types/return';
import { ConstantsCodesObjectType, ConstantsCodeType } from 'src/types/constantsCodes';
import HistoryBlock from './HistoryBlock';
import Grid, { GridItem } from 'src/components/Grid';
import ProductsTable from './ProductsTable';
import NewProductBlock from './NewProductBlock';
import { sizes } from 'src/themes/default';
import Detail from './Detail';
import { ReturnChangelogType } from 'src/types/returnDetail';
import { OptionType } from 'src/components/Select';
import { OrderType } from 'src/types/order';
import FilesBlock from './FilesBlock';
import { ProductListType } from 'src/types/product';
import OrderDetail from './OrderDetail';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface RenderComponentsPropsType {
    formRef: React.RefObject<HTMLFormElement>;
    productsFormRef: React.RefObject<HTMLFormElement>;
    data: ReturnType | null;
    onChange: OnChangeType<EditKeysType>;
    onChangeProduct: OnChangeType<EditKeysType>;
    editData: ReturnType;
    editErrors: FormErrorsType;
    newReturn: boolean;
    disableEdit: boolean;
    isAttributeEditDisabled: (key: string) => boolean;
    permissionEditAll: boolean;
    permissionEditNote: boolean;
    returnStatusCodes: ConstantsCodeType[];
    returnStatusCodesObject: ConstantsCodesObjectType;
    retunReasonCodes: ConstantsCodeType[];
    retunReasonCodesObject: ConstantsCodesObjectType;
    returnResolutionCodes: ConstantsCodeType[];
    returnResolutionCodesObject: ConstantsCodesObjectType;
    boolNumberCodesObject: ConstantsCodesObjectType;
    boolNumberCodes: ConstantsCodeType[];
    lineStateCodesObject: ConstantsCodesObjectType;
    transportPaidByCodesObject: ConstantsCodesObjectType;
    transportPaidByCodes: ConstantsCodeType[];
    shipperCodes: ConstantsCodeType[];
    serviceCodes: ConstantsCodeType[];
    sourceSysCodesObject: ConstantsCodesObjectType;
    sourceSysCodes: ConstantsCodeType[];
    orderTypeCodesObject: ConstantsCodesObjectType;
    activeTab: string;
    changelog: ReturnChangelogType | null;
    createReturnFromList: boolean;
    ordersOptions: OptionType[];
    orderData: OrderType | null;
    productsData: ProductListType[] | null;
    allowedStatuses: ConstantsCodeType[];
    skladonUser?: number;
    isDcixReturn: boolean;
}

const RenderComponents: FC<RenderComponentsPropsType> = (props) => {
    const renderDetail = () => (
        <>
            <form ref={props.formRef}>
                <FormBlock>
                    <Grid>
                        <GridItem cols={6}>
                            <Detail
                                onChange={props.onChange}
                                editData={props.editData}
                                editErrors={props.editErrors}
                                newReturn={props.newReturn}
                                disableEdit={props.disableEdit}
                                transportPaidByCodes={props.transportPaidByCodes}
                                sourceSysCodes={props.sourceSysCodes}
                                returnStatusCodes={props.returnStatusCodes}
                                allowedStatuses={props.allowedStatuses}
                            />
                        </GridItem>
                        <GridItem cols={6}>
                            <OrderDetail
                                onChange={props.onChange}
                                editData={props.editData}
                                editErrors={props.editErrors}
                                newReturn={props.newReturn}
                                disableEdit={props.disableEdit}
                                createReturnFromList={props.createReturnFromList}
                                ordersOptions={props.ordersOptions}
                                orderData={props.orderData}
                                shipperCodes={props.shipperCodes}
                                serviceCodes={props.serviceCodes}
                                permissionEditNote={props.permissionEditNote}
                                isDcixReturn={props.isDcixReturn}
                            />
                        </GridItem>
                    </Grid>
                </FormBlock>
            </form>
            <FilesBlock
                onChange={props.onChange}
                editData={props.editData}
                editErrors={props.editErrors}
                isAttributeEditDisabled={props.isAttributeEditDisabled}
                skladonUser={props.skladonUser}
            />
            {!props.disableEdit && (
                <FormBlock sx={{ marginTop: sizes.blocks_top_MG }}>
                    <NewProductBlock
                        data={props.editData.RETURNED_ORDER_PRODUCTS || []}
                        onChange={(value: any) => props.onChange('RETURNED_ORDER_PRODUCTS', value, false)}
                        disableEdit={props.disableEdit}
                        retunReasonCodes={props.retunReasonCodes}
                        editErrors={props.editErrors}
                        skladonUser={props.skladonUser}
                    />
                </FormBlock>
            )}
            <form ref={props.productsFormRef}>
                <ProductsTable
                    data={props.editData.RETURNED_ORDER_PRODUCTS || []}
                    newReturn={props.newReturn}
                    onChange={(value: any, error: boolean, errorKey?: string) => {
                        props.onChangeProduct('RETURNED_ORDER_PRODUCTS', value, error, errorKey);
                    }}
                    disableEdit={props.disableEdit}
                    returnResolutionCodes={props.returnResolutionCodes}
                    retunReasonCodes={props.retunReasonCodes}
                    editErrors={props.editErrors}
                    permissionEditAll={props.permissionEditAll}
                    skladonUser={props.skladonUser}
                />
            </form>
        </>
    );

    const renderHistory = () => (
        <HistoryBlock
            changelog={props.changelog}
            returnStatusCodesObject={props.returnStatusCodesObject}
            retunReasonCodesObject={props.retunReasonCodesObject}
            lineStateCodesObject={props.lineStateCodesObject}
            returnResolutionCodesObject={props.returnResolutionCodesObject}
            boolNumberCodesObject={props.boolNumberCodesObject}
            sourceSysCodesObject={props.sourceSysCodesObject}
            transportPaidByCodesObject={props.transportPaidByCodesObject}
            orderTypeCodesObject={props.orderTypeCodesObject}
            productsData={props.data?.RETURNED_ORDER_PRODUCTS?.map((product) => ({ID: product.PRODUCT_ID, SKU: product.SKU}) ) || []}
            skladonUser={props.skladonUser}
        />
    );

    switch (props.activeTab) {
        case 'detail':
            return renderDetail();

        case 'history':
        default:
            return renderHistory();
    }
};

export default RenderComponents;
